import { AuthContainer, SignUp } from '@fhs/auth';

export default function SignUpPage() {
  return (
    <AuthContainer>
      <SignUp />
    </AuthContainer>
  );
}
